import { Attempt } from '@/common/types/session';
import { formatTimeTaken } from '@/common/utils/datetime';
import { getCorrectSegmentsForMorphMaster } from '@/common/utils/getCorrectSegments';
import { TableCell, TableHead, TableRow } from '@shadcn/components/table';
import GenericAttemptTable, {
  getControlIcon,
  getHasControl,
  renderStudentAnswer,
} from './GenericAttemptTable';

interface MorphMasterAttemptTableProps {
  attempts: Attempt[];
}
export default function MorphMasterAttemptTable({
  attempts,
}: MorphMasterAttemptTableProps) {
  const hasControl = getHasControl(attempts);

  return (
    <GenericAttemptTable
      renderHeader={() => (
        <TableRow className="hover:bg-white">
          <TableHead>Attempt</TableHead>
          <TableHead>Served Word</TableHead>
          <TableHead>Student Attempt</TableHead>
          <TableHead>Time Taken</TableHead>
          {hasControl && <TableHead>Control</TableHead>}
        </TableRow>
      )}
      renderData={() =>
        attempts.map((attempt, index) => (
          <TableRow key={index} className="hover:bg-white">
            <TableCell>{index + 1}</TableCell>

            <TableCell>{attempt.correctAnswer}</TableCell>
            <TableCell>
              {renderStudentAnswer({
                attempt,
                getCorrectSegments: getCorrectSegmentsForMorphMaster,
              })}
            </TableCell>
            <TableCell>
              {formatTimeTaken(attempt.startedAt, attempt.endedAt)}
            </TableCell>
            {hasControl && (
              <TableCell className="pl-6">
                {getControlIcon(attempt.control!)}
              </TableCell>
            )}
          </TableRow>
        ))
      }
      isEmpty={attempts.length === 0}
    />
  );
}
